import profileRequest from '@stelecom/ui-react/components/requests/profileRequestIntegration';

enum EContactStatuses {
    confirmed = 'confirmed',
    unconfirmed = 'unconfirmed'
}


interface IContact {
    id: number,
    value: string,
    status: EContactStatuses
}

interface IPhoneContact extends IContact {
    // TODO: описать значения
    phoneTypeId: number
}

interface UserContacts {
    agreementId: string;
    agreement: string;
    agreementTypeId: string;
    fio: string;
    photoUrl: string;
    address: Address;
    cityId: number;
}
export interface Address {
    street: string;
    streetId: number;
    house: number;
    building?: any;
    flat: number;
    address: string;
}
interface UserContactsWithPhone {
    emails: IContact[],
    phones: IPhoneContact[]
}

/**
 * получение контакных данных клиента
 * @param {string} domain
 * @param {string} accessToken
 * @returns {Promise<{email:{id: number, value: string, status:
 *     string}[],phone:{id: number, value: string, status: string}[]}>}
 */
export async function getContacts(domain: string, accessToken: string): Promise<UserContactsWithPhone> {
    const response = await profileRequest(domain, accessToken)
        .get('/contact');
        // console.log('parsed', parseContacts(response.data));
    return parseContacts(response.data);
}

/**
 * @param data
 * @return {{emails:{id: number, value: string, status: string}[],phones:{id:
 *     number, value: string, status: string, phoneTypeId: number}[]}}
 */

function parseContacts(data: any): UserContactsWithPhone {
    // const contacts = data.contacts.contacts;
    const out = {};
    for (const key in data) {
        // @ts-ignore
        out[key] = parseContactsItems(data[key]);
    }
    return <UserContactsWithPhone>out;
}


/**
 * получение контакных данных и информации о договоре клиента
 * @param {string} domain
 * @param {string} accessToken
 * @returns {Promise<{email:{id: number, value: string, status:
 *     string}[],phone:{id: number, value: string, status: string}[]}>}
 */
export async function getPersonal(domain: string, accessToken: string): Promise<UserContacts> {
    const response = await profileRequest(domain, accessToken)
        .get('/info/personal');
    return response.data;
}

/**
 * @param data
 * @return {{email:{id: number, value: string, status: string}[],phone:{id:
 *     number, value: string, status: string, phoneTypeId: number}[]}}
 */
/*
function parseContacts(data: any): UserContactsWithPhone {
    const contacts = data.contacts.contacts;
    const out = {};
    for (const key in contacts) {
        // @ts-ignore
        out[key] = parseContactsItems(contacts[key]);
    }
    return <UserContactsWithPhone>out;
}
*/

/**
 * @param data
 * @return {{id: number, value: string, status: string}[]}
 */
function parseContactsItems(data: any): IContact | IPhoneContact {
    return data.map(parseContactsItem);
}

/**
 * @param data
 * @return {{id: number, value: string, status: string, phoneTypeId?: number}}
 */
function parseContactsItem(data: any): IContact | IPhoneContact {
    const out: any = {
        id: data.id,
        status: data.status,
    };
    if (Array.isArray(data.value)) {
        out.value = data.value[0];
    } else {
        out.value = data.value;
    }
    if (data.phoneTypeId) {
        out.phoneTypeId = data.phoneTypeId;
    }

    return out;
}
